import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getImagesList: any = createAsyncThunk<any>(
	'getImagesList',
	async (data: any, { rejectWithValue }) => {
		try {
			if (data.imageType == 'NEEDS') {
				let arr: any = { data: { list: [], count: 0 } };
				return arr;
			} else {
				const response = await httpService.get(
					'/productService/imageUpload',
					{
						params: data
					}
				);
				return response.data;
			}
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteImageList: any = createAsyncThunk<any>(
	'deleteImageList',
	async (data: any, { rejectWithValue }) => {
		try {
			// console.log(data);
			const response = await httpService.put(
				'/productService/imageUpload',
				data
			);
			return response.data;
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getImagesSignature: any = createAsyncThunk<any>(
	'getImagesSignature',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/imageUpload/getUploadSignature',
				{
					params: data
				}
			);
			return response.data;
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getImagesMatch: any = createAsyncThunk<any>(
	'getImagesMatch',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/imageV2/imagesMatch',
				{
					params: data
				}
			);
			return response.data;
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const imagesMatchApprove: any = createAsyncThunk<any>(
	'imagesMatchApprove',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/imageUpload/imagesMatch',
				data
			);
			return response.data;
			// console.log(response.data);
		} catch (error: any) {
			// console.log(error?.response?.data)
			return rejectWithValue(error?.response?.data);
		}
	}
);
